import React, {memo, useEffect} from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import {
    ColorTokensMap,
    FontFamilyTokensMap,
    TypographyBaseProps,
    FontDecorationToken,
    FontTransformToken,
    FontSizeTokensMap,
    TextAlignTokens,
    FontFamilyTokens, TypographyTypeTokens, TypographyTypeDLS, ColorTokens,
} from '@voltmoney/schema';
import {isMobileViewApp} from "../stack/utils";
import {getParameters, isAndroid, isFromTDLPlatform, isIos} from "../../utils/utils";
import { PLATFORM_NAME } from '../../types/regix';

/**
 * Raw Component with Derived props + Theme
 */

const  TypographyBaseDLS: React.FunctionComponent<
    TypographyBaseProps
> = ({
         id,
         label = 'Lorem ipsum dolor sit amet',
         color = ColorTokens.Grey_Night,
         fontSize,
         fontFamily = FontFamilyTokens.Inter,
         // fontWeight = '700',
         textDecorationLine = FontDecorationToken.none,
         textTransform = FontTransformToken.none,
         textAlign = TextAlignTokens.auto,
         ellipsizeMode,
         numberOfLines = 0,
         lineHeight = 0,
         marginRight,
         typeDLS,
         ...props
     }) => {



    useEffect(()=> {
        if(Platform.OS === 'web')
        if(isFromTDLPlatform())
     loadFont()
    },[])
    let isFromTdl = false
    let params = null
    const isFromMobileViewApp = isMobileViewApp()

   if(Platform.OS === 'web'){
    params = getParameters(window?.location.href)

     
    isFromTdl = params.platform === PLATFORM_NAME.TDL
    }
    const theme = ThemeProvider.getTheme();
    const colorMapping: ColorTokensMap =
        theme.colors;
    const fontFamilyMapping: FontFamilyTokensMap =
        theme.fontFamily;

    const _isFontMobile = () => {
        if(Platform.OS !== "web") {
            return true;
        } else if (isFromMobileViewApp){
            return true;
        } else {
            return false;
        }
    }

    const loadFont = () => {
        const fontUrl = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonBold.otf';
        const fontFace = new FontFace('MyCustomFont', `url(${fontUrl})`);

        const interSimonson = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/simonsonRegular.otf'
        const interSimonsonFontFace = new FontFace('InterSimonson', `url(${interSimonson})`);

        fontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
        interSimonsonFontFace.load().then((loadedFontFace) => {
            document.fonts.add(loadedFontFace);
        }).catch((error) => {
            console.error('Failed to load font:', error);
        });
    };
    const isFontMobile = _isFontMobile();

    const dlsStyle = (typeDLS) => {
        switch(typeDLS) {

            //Header styles tokens
            case `${TypographyTypeDLS.H1R}`:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 32 : 24,
                        lineHeight: isFontMobile ? 40 : 32,
                        fontFamily: (isAndroid()) ? 'Poppins-Regular' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.H1S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 32 : 24,
                        lineHeight: isFontMobile ? 40 : 32,
                        fontFamily: (isAndroid()) ? 'Poppins-SemiBold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.H1B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 32 : 24,
                        lineHeight: isFontMobile ? 40 : 32,
                        fontFamily: (isAndroid()) ? 'Poppins-Bold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.H2R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 24 : 18,
                        lineHeight: isFontMobile ? 32 : 26,
                        fontFamily: (isAndroid()) ? 'Poppins-Regular' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.H2S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 24 : 18,
                        lineHeight: isFontMobile ? 32 : 26,
                        fontFamily: (isAndroid()) ? 'Poppins-SemiBold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.H2B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 24 : 18,
                        lineHeight: isFontMobile ? 32 : 26,
                        fontFamily: (isAndroid()) ? 'Poppins-Bold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.H3R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 20 : 16,
                        lineHeight: isFontMobile ? 28 : 24,
                        fontFamily: (isAndroid()) ? 'Poppins-Regular' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.H3S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 20 : 16,
                        lineHeight: isFontMobile ? 28 : 24,
                        fontFamily: (isAndroid()) ? 'Poppins-SemiBold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.H3B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 20 : 16,
                        lineHeight: isFontMobile ? 28 : 24,
                        fontFamily: (isAndroid()) ? 'Poppins-Bold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.H4R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Poppins-Regular' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.H4S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Poppins-SemiBold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.H5S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: 14,
                        lineHeight: 20,
                        fontFamily: 'Poppins',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.H4B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Poppins-Bold' : isFromTdl ? 'MyCustomFont'  : 'Poppins',
                        fontWeight: '700'
                    }
                })
                break;


            //Body styles tokens
            // /InterSimonson

            case TypographyTypeDLS.B0R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Regular' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.B0M:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Medium' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '500'
                    }
                })
                break;
            case TypographyTypeDLS.B0S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-SemiBold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.B0B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 16 : 14,
                        lineHeight: isFontMobile ? 24 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Bold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.B1R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 14 : 14,
                        lineHeight: isFontMobile ? 20 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Regular' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.B1M:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 14 : 14,
                        lineHeight: isFontMobile ? 20 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Medium' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '500'
                    }
                })
                break;
            case TypographyTypeDLS.B1S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 14 : 14,
                        lineHeight: isFontMobile ? 20 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-SemiBold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.B1B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 14 : 14,
                        lineHeight: isFontMobile ? 20 : 20,
                        fontFamily: (isAndroid()) ? 'Inter-Bold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.B2R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 12 : 12,
                        lineHeight: isFontMobile ? 18 : 18,
                        fontFamily: (isAndroid()) ? 'Inter-Regular' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.B2M:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 12 : 12,
                        lineHeight: isFontMobile ? 18 : 18,
                        fontFamily: (isAndroid()) ? 'Inter-Medium' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '500'
                    }
                })
                break;
            case TypographyTypeDLS.B2S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 12 : 12,
                        lineHeight: isFontMobile ? 18 : 18,
                        fontFamily: (isAndroid()) ? 'Inter-SemiBold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.B2B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 12 : 12,
                        lineHeight: isFontMobile ? 18 : 18,
                        fontFamily: (isAndroid()) ? 'Inter-Bold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '700'
                    }
                })
                break;
            case TypographyTypeDLS.B3R:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 10 : 10,
                        lineHeight: isFontMobile ? 16 : 16,
                        fontFamily: (isAndroid()) ? 'Inter-Regular' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '400'
                    }
                })
                break;
            case TypographyTypeDLS.B3M:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 10 : 10,
                        lineHeight: isFontMobile ? 16 : 16,
                        fontFamily: (isAndroid()) ? 'Inter-Medium' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '500'
                    }
                })
                break;
            case TypographyTypeDLS.B3S:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 10 : 10,
                        lineHeight: isFontMobile ? 16 : 16,
                        fontFamily: (isAndroid()) ? 'Inter-SemiBold' : isFromTdl ? 'InterSimonson'  : 'Inter ',
                        fontWeight: '600'
                    }
                })
                break;
            case TypographyTypeDLS.B3B:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: isFontMobile ? 10 : 10,
                        lineHeight: isFontMobile ? 16 : 16,
                        fontFamily: (isAndroid()) ? 'Inter-Bold' : isFromTdl ? 'InterSimonson'  : 'Inter',
                        fontWeight: '700'
                    }
                })
                break;
            default:
                return StyleSheet.create({
                    typographyStyle: {
                        fontSize: 32,
                        lineHeight: 40,
                        fontFamily: isFromTdl ?'MyCustomFont' : 'Poppins',
                        fontWeight: '700'
                    }
                })
        }
    }

    if (!label) return <></>;
    else
        return (
            <Text
                nativeID={id}
                style={[
                    typeDLS && dlsStyle(typeDLS).typographyStyle,
                    {
                        // fontFamily: applyFontFamilyWithWeightRN,
                        // fontWeight: fontWeight,
                        color: colorMapping[color],
                        // fontSize: fontSizeMapping[fontSize],
                        textTransform: textTransform,
                        textDecorationLine: textDecorationLine,
                        textAlign: textAlign,
                        padding: 0,
                        marginRight: marginRight,
                    },
                ]}
                {...props}
                numberOfLines={numberOfLines}
            >
                {label}
            </Text>
        );
};
export default memo(TypographyBaseDLS);
export { TypographyBaseDLS };

const parseFontWeightRN = (size: string) => {
    switch (size) {
        case '100':
        case '200':
        case '300':
            return '-Light';
        case '400':
            return '-Regular';
        case '500':
            return '-SemiBold';
        case '600':
        case '700':
            return '-Bold';
        case '800':
            return '-ExtraBold';
        default:
            return '-Regular';
    }
};
